import Vue from 'vue';
import Router from 'vue-router';
import Orders from './views/Orders.vue';
import Login from './views/Login.vue';
import Admin from './views/Admin.vue';
import Batches from './views/Batches.vue';
import ResetPassword from './views/ResetPassword.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'label-active',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'orders' },
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
    },
    {
      path: '/orders/errors',
      name: 'errors',
      component: Orders,
    },
    {
      path: '/orders/urgent',
      name: 'urgent',
      component: Orders,
    },
    {
      path: '/orders/processed',
      name: 'processed',
      component: Orders,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/users',
      name: 'allUsers',
      component: Admin,
    },
    {
      path: '/users/active',
      name: 'activeUsers',
      component: Admin,
    },
    {
      path: '/users/inactive',
      name: 'inactiveUsers',
      component: Admin,
    },
    {
      path: '/users/admin',
      name: 'adminUsers',
      component: Admin,
    },
    {
      path: '/batches',
      name: 'allBatches',
      component: Batches,
    },
    {
      path: '/batches/week',
      name: 'thisWeeksBatches',
      component: Batches,
    },
    {
      path: '/batches/today',
      name: 'todaysBatches',
      component: Batches,
    },
    {
      path: '/resetpassword',
      name: 'resetPassword',
      component: ResetPassword,
    },
  ],
});
